import type { Level, SmartConfiguration } from "types";

export const isAddFavouriteVisible = (
  isHeroBanner:boolean, 
  smartConfiguration: SmartConfiguration | null, 
  rootId: number | null, 
  courseId: number | null,
  learningObjectTypology: Level,
  simple:boolean,
  isBookmarkPage: boolean,
  isEditorial?: boolean,
  isExplorePage?: boolean
) =>{
  //HERO BANNER
  if(   
    isHeroBanner 
    && smartConfiguration?.funcFavourites
    && ((!rootId || learningObjectTypology === "PATH") 
    && (!courseId  || learningObjectTypology === "COURSE"))
  ){
    return true;
  }

  //CARDs 
  if(
    (!simple || isBookmarkPage || isExplorePage) 
    && !isEditorial 
    && smartConfiguration?.funcFavourites 
    && (!rootId && !courseId)
  ) {
    return true;
  }

  return false;
};
